/* eslint-disable camelcase */
import type { FunctionComponent } from 'react';

export interface ManomanoProLogoProps {
  className?: string;
  height?: string;
  theme?: 'dark' | 'light';
  title?: string;
  width?: string;
}

export const ManomanoProLogo: FunctionComponent<ManomanoProLogoProps> = ({
  theme = 'light',
  className,
  width = '100%',
  height = '100%',
  title = 'ManomanoPro logo',
}) => {
  const textColor = theme === 'dark' ? '#0A1F44' : '#ffffff';

  return (
    <svg
      className={className}
      aria-label={title}
      width={width}
      height={height}
      viewBox="0 0 232 42"
    >
      <defs>
        <linearGradient
          id="ManomanoProLogo"
          x1="17.337%"
          x2="72.327%"
          y1="78.408%"
          y2="30.539%"
        >
          <stop stopColor="#E6685A" offset=".00044" />
          <stop stopColor="#FFB950" offset="1" />
        </linearGradient>
      </defs>
      <g fillRule="evenodd">
        <path
          d="M205.351 17.88c0 2.028-.576 3.594-1.728 4.7-1.152 1.105-2.789 1.658-4.91 1.658h-1.328v6.023h-4.724V12.104h6.052c2.209 0 3.868.501 4.976 1.503 1.108 1.002 1.662 2.426 1.662 4.272zm-7.966 2.359h.862c.71 0 1.273-.207 1.692-.621.419-.414.628-.985.628-1.714 0-1.225-.654-1.838-1.962-1.838h-1.22v4.173zm18.66-4.297c.406 0 .793.033 1.16.1l.263.049-.419 4.582c-.382-.099-.913-.149-1.59-.149-1.021 0-1.763.243-2.225.727-.463.484-.694 1.182-.694 2.093v6.917h-4.677V16.19h3.48l.73 2.247h.228a4.794 4.794 0 0 1 1.632-1.807c.698-.46 1.402-.69 2.112-.69zm3.825 2.142c1.374-1.352 3.039-2.001 5.048-2.001 2.008 0 3.7.649 5.047 2 1.374 1.325 2.035 3.029 2.035 5.11 0 2.083-.687 3.786-2.035 5.084-1.348 1.298-3.013 1.946-5.047 1.946-2.009 0-3.7-.648-5.048-1.946-1.348-1.325-2.009-3.028-2.009-5.083 0-2.082.661-3.786 2.009-5.11zm5.048 8.192c1.48 0 2.695-1.217 2.695-3.082 0-1.893-1.19-3.137-2.695-3.137-1.48 0-2.696 1.271-2.696 3.137.026 1.865 1.216 3.082 2.696 3.082z"
          fill="#FFB950"
        />
        <path
          d="M104.928 18.907c1.387-1.294 3.067-1.914 5.093-1.914s3.733.62 5.092 1.914c1.387 1.267 2.053 2.896 2.053 4.888 0 1.991-.693 3.62-2.053 4.862-1.36 1.242-3.04 1.863-5.092 1.863-2.026 0-3.733-.621-5.093-1.863-1.36-1.267-2.026-2.896-2.026-4.862 0-1.992.693-3.621 2.026-4.888zm5.12 7.836c1.493 0 2.72-1.164 2.72-2.948 0-1.81-1.2-3-2.72-3-1.494 0-2.72 1.215-2.72 3 0 1.784 1.2 2.948 2.72 2.948zM97.01 17.02c3.066 0 4.399 1.603 4.399 4.422v8.768h-4.96v-7.76c0-.8-.293-1.266-.932-1.266-.587 0-1.733.207-2.453.698v8.354h-4.906V17.277h4.052l.267.983c.8-.517 2.693-1.19 4.186-1.241h.347zm-32.182-2.561l7.119 1.216V30.57l-5.2 1.707V20.252l-5.465 9.517H58.43l-3.706-8.87-3.76 9.31h-5.572l6.24-15.777 5.038-1.319 4.053 8.458 4.106-7.113zm9.839 3.207c3.572-.595 11.678-2.457 11.704 4.707v7.863h-3.759l-.293-.62s-1.307.956-4.133.956c-3.093 0-4.72-2.069-4.72-4.06 0-3.285 2.96-4.061 6.32-4.061h2.346c0-1.345-.826-1.836-2.586-1.81-2.48 0-4.453.543-4.88.672v-3.647zm7.492 7.656v-.13l-2.213-.025c-1.733 0-2.56.258-2.56 1.112 0 .853.72 1.19 1.947 1.19 1.84 0 2.826-.647 2.826-2.147zm95.238-6.414c1.386-1.294 3.066-1.914 5.092-1.914 2.027 0 3.733.62 5.093 1.914 1.386 1.267 2.053 2.896 2.053 4.888 0 1.991-.693 3.62-2.053 4.862-1.36 1.242-3.04 1.863-5.093 1.863-2.026 0-3.732-.621-5.092-1.863-1.36-1.267-2.027-2.896-2.027-4.862 0-1.992.667-3.621 2.027-4.888zm5.092 7.836c1.493 0 2.72-1.164 2.72-2.948 0-1.81-1.2-3-2.72-3-1.493 0-2.72 1.215-2.72 3 .027 1.784 1.227 2.948 2.72 2.948zm-13.011-9.724c3.066 0 4.373 1.603 4.373 4.422v8.768h-4.933v-7.76c0-.8-.293-1.266-.933-1.266-.587 0-1.733.207-2.453.698v8.354h-4.906V17.277h4.053l.266.983c.8-.517 2.693-1.19 4.186-1.241h.347zm-32.181-2.561l7.118 1.216V30.57l-5.199 1.707V20.252l-5.492 9.517h-2.826l-3.707-8.87-3.759 9.31h-5.572l6.239-15.777 5.039-1.319 4.053 8.458 4.106-7.113zm9.811 3.207c3.6-.595 11.705-2.457 11.705 4.707v7.863h-3.76l-.293-.62s-1.306.956-4.132.956c-3.093 0-4.72-2.069-4.72-4.06 0-3.285 2.96-4.061 6.32-4.061h2.346c0-1.345-.827-1.836-2.586-1.81-2.48 0-4.453.543-4.88.672v-3.647zm7.492 7.656v-.13l-2.213-.025c-1.733 0-2.56.258-2.56 1.112 0 .853.72 1.19 1.947 1.19 1.84 0 2.826-.647 2.826-2.147z"
          fill={textColor}
          fillRule="nonzero"
        />
        <path
          d="M42.552 15.485L31.063 1.358A3.71 3.71 0 0 0 27.638.04L9.622 2.92a3.703 3.703 0 0 0-2.858 2.313L.237 22.24a3.746 3.746 0 0 0 .566 3.632l11.49 14.127a3.71 3.71 0 0 0 3.425 1.319l18.015-2.88a3.703 3.703 0 0 0 2.859-2.314l6.526-17.005a3.616 3.616 0 0 0-.566-3.633z"
          fill="url(#ManomanoProLogo)"
          fillRule="nonzero"
        />
        <path
          d="m26.261 12.403-4.05 7.086-3.995-8.393-4.987 1.28-6.169 15.69h5.497l3.728-9.256 3.647 8.811h2.815l5.417-9.439v12.08l5.122-1.7v-14.93z"
          fill="#ffffff"
          fillRule="nonzero"
        />
      </g>
    </svg>
  );
};

ManomanoProLogo.displayName = 'ManomanoProLogo';
